export const activeModal = state => state.modalManager.activeModal;
